import { Box, Modal, ModalContent, ModalOverlay, ModalFooter } from '@chakra-ui/react';
import { Button, Text } from '@mercator-gcp/grout';

const contentStyle = {
  maxWidth: '500px',
  width: 'fit-content',
};

const titleStyle = {
  paddingBottom: 'padding_8',
};

const modalBodyStyle = {
  padding: 'padding_16',
  paddingBottom: 'padding_16',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: 'padding_16',
  paddingTop: '0px',
};

type ConfirmLocationChangeModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmLocationChangeModal = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmLocationChangeModalProps) => {
  const handleConfirmLocationChange = () => {
    onConfirm();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={contentStyle}>
        <Box sx={modalBodyStyle}>
          <Text.Lead sx={titleStyle}>Changing states will clear some filters</Text.Lead>
          <Text as="p">Filter options differ slightly by region.</Text>
        </Box>
        <ModalFooter sx={modalFooterStyle}>
          <Button variant="functional" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmLocationChange}>
            Yes, change state
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmLocationChangeModal;
